<template>
  <div class="p-list-representation-province-left col-lg-2 justify-content-lg-end d-flex p-list-representation-export-excel">
      <export-excel
      :data   = "excelData"
       name   = "excelExport.xls"
      >
      <button type="button" class="btn btn-primary btn-sm  p-list-representation-btn">ثبت اکسل بانک</button>
    </export-excel>
  </div>
</template>

<script>


export default {
  name: "excelExportBtn",
  components: {
  },

  props: {
    excelData   : {type:Array,default:[]},
  },

  data() {
    return {

    }
  },

  watch: {

  },

  created() {

  },

  mounted() {
  },

  methods: {

  }


}
</script>
